import { useEffect, useRef, useState } from "react";

const Reveal = ({ as: Tag = "div", delay = 0, className = "", children, ...rest }) => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    if (typeof IntersectionObserver === "undefined") {
      setShown(true);
      return;
    }
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setShown(true);
            obs.unobserve(node);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" },
    );
    obs.observe(node);
    return () => obs.disconnect();
  }, []);

  const stagger = delay >= 1 && delay <= 5 ? `mk-reveal-${delay}` : "";
  return (
    <Tag ref={ref} className={`mk-reveal ${stagger} ${shown ? "is-in" : ""} ${className}`.trim()} {...rest}>
      {children}
    </Tag>
  );
};

export default Reveal;
